/**
 * In-progress composer values (unsaved) for library add and assessment compose.
 */

import type { QuestionFormValues } from "@/components/question-composer/composer-form"
import {
  readTieredJson,
  removeTieredJson,
  removeTieredJsonByMark,
  writeTieredJson,
} from "@/lib/question-version-history/durable-storage"

const STORAGE_MARK = "composer-form-draft:v1:"
const memoryStash = new Map<string, QuestionFormValues>()

function storageKey(questionId: string) {
  return `exxat-ds:${STORAGE_MARK}${questionId}`
}

export function readComposerFormDraft(
  questionId: string,
): QuestionFormValues | null {
  if (!questionId) return null
  const cached = memoryStash.get(questionId)
  if (cached) return cached
  const parsed = readTieredJson(questionIdStorageKey(questionId), isFormDraft)
  if (!parsed) return null
  memoryStash.set(questionId, parsed)
  return parsed
}

function questionIdStorageKey(questionId: string) {
  return storageKey(questionId)
}

function isFormDraft(value: unknown): value is QuestionFormValues {
  return Boolean(value && typeof value === "object")
}

export function writeComposerFormDraft(
  questionId: string,
  values: QuestionFormValues,
) {
  if (!questionId) return
  memoryStash.set(questionId, values)
  writeTieredJson(questionIdStorageKey(questionId), values)
}

export function clearComposerFormDraft(questionId: string) {
  memoryStash.delete(questionId)
  removeTieredJson(questionIdStorageKey(questionId))
}

export function clearAllComposerFormDrafts() {
  memoryStash.clear()
  removeTieredJsonByMark(STORAGE_MARK)
}
